/* eslint-disable no-loss-of-precision */
// Ears
import NormalButterfly from '../Ears/NormalButterfly'
import NormalOval from '../Ears/NormalOval'
import SkinnyPointy from '../Ears/SkinnyPointy'
import NormalButterfly2 from '../Ears/NormalButterfly2'
import NormalPointy from '../Ears/NormalPointy'
import SkinnyLongPointy from '../Ears/SkinnyLongPointy'
import SkinnyRound from '../Ears/SkinnyRound'
import NormalCircular from '../Ears/NormalCircular'
import NormalRound from '../Ears/NormalRound'
import SkinnyLongRound from '../Ears/SkinnyLongRound'
import SkinnySquarePointy from '../Ears/SkinnySquarePointy'
import SkinnyDiagonalPointy from '../Ears/SkinnyDiagonalPointy'

const data = [
  {
    id: 'SkinnyLongPointy',
    svg: SkinnyLongPointy,
    positioning: {
      pointNarrow: {
        y: 94.07093811035156,
        scaleX: 0.8,
      },
      pointMedium: {
        y: 92.29844665527344,
        scaleX: 0.95,
      },
      pointWide: {
        y: 91.39532470703125,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 92.5333251953125,
        scaleX: 0.8,
      },
      roundMedium: {
        y: 90,
        scaleX: 0.9,
      },
      roundWide: {
        y: 92.88995361328125,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 93.33390808105469,
        scaleX: 0.8,
      },
      squareMedium: {
        y: 92.63810729980469,
        scaleX: 0.95,
      },
      squareWide: {
        y: 92.94709777832031,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'NormalButterfly',
    svg: NormalButterfly,
    positioning: {
      pointNarrow: {
        y: 97.60487365722656,
        scaleX: 0.7,
      },
      pointMedium: {
        y: 95.88203430175781,
        scaleX: 0.8,
      },
      pointWide: {
        y: 93.82890319824219,
        scaleX: 0.9,
      },
      roundNarrow: {
        y: 97.62471008300781,
        scaleX: 0.65,
      },
      roundMedium: {
        y: 98.19230651855469,
        scaleX: 0.75,
      },
      roundWide: {
        y: 93.18919372558594,
        scaleX: 0.9,
      },
      squareNarrow: {
        y: 99.49278259277344,
        scaleX: 0.7,
      },
      squareMedium: {
        y: 96.279296875,
        scaleX: 0.8,
      },
      squareWide: {
        y: 94.67413330078125,
        scaleX: 0.9,
      },
    },
  },
  {
    id: 'NormalOval',
    svg: NormalOval,
    positioning: {
      pointNarrow: {
        y: 99.38557434082031,
        scaleX: 0.65,
      },
      pointMedium: {
        y: 99.23249816894531,
        scaleX: 0.75,
      },
      pointWide: {
        y: 93.31362915039062,
        scaleX: 0.9,
      },
      roundNarrow: {
        y: 99.43838500976562,
        scaleX: 0.65,
      },
      roundMedium: {
        y: 99.43203735351562,
        scaleX: 0.75,
      },
      roundWide: {
        y: 101.49435424804688,
        scaleX: 0.85,
      },
      squareNarrow: {
        y: 100,
        scaleX: 0.7,
      },
      squareMedium: {
        y: 97.34912109375,
        scaleX: 0.75,
      },
      squareWide: {
        y: 95.29249572753906,
        scaleX: 0.9,
      },
    },
  },
  {
    id: 'SkinnyPointy',
    svg: SkinnyPointy,
    positioning: {
      pointNarrow: {
        y: 99.22610473632812,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 98.34397888183594,
        scaleX: 0.85,
      },
      pointWide: {
        y: 91.11351013183594,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 96.51261901855469,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 98.13328552246094,
        scaleX: 0.85,
      },
      roundWide: {
        y: 95.97993469238281,
        scaleX: 1.0,
      },
      squareNarrow: {
        y: 97.37928771972656,
        scaleX: 0.8,
      },
      squareMedium: {
        y: 98.638916015625,
        scaleX: 0.85,
      },
      squareWide: {
        y: 93.08731079101562,
        scaleX: 1.0,
      },
    },
  },
  {
    id: 'NormalButterfly2',
    svg: NormalButterfly2,
    positioning: {
      pointNarrow: {
        y: 98.87466430664062,
        scaleX: 0.7,
      },
      pointMedium: {
        y: 98.41908264160156,
        scaleX: 0.78,
      },
      pointWide: {
        y: 93.87083435058594,
        scaleX: 0.9,
      },
      roundNarrow: {
        y: 95.17843627929688,
        scaleX: 0.7,
      },
      roundMedium: {
        y: 95.95036315917969,
        scaleX: 0.8,
      },
      roundWide: {
        y: 96.10182189941406,
        scaleX: 0.9,
      },
      squareNarrow: {
        y: 98.74380493164062,
        scaleX: 0.7,
      },
      squareMedium: {
        y: 93.38858032226562,
        scaleX: 0.8,
      },
      squareWide: {
        y: 96.82647705078125,
        scaleX: 0.9,
      },
    },
  },
  {
    id: 'NormalPointy',
    svg: NormalPointy,
    positioning: {
      pointNarrow: {
        y: 99.66014099121094,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 100.87692260742188,
        scaleX: 0.85,
      },
      pointWide: {
        y: 91.12574768066406,
      },
      roundNarrow: {
        y: 98.62713623046875,
        scaleX: 0.7,
      },
      roundMedium: {
        y: 97.65196228027344,
        scaleX: 0.85,
      },
      roundWide: {
        y: 95.72265625,
        scaleX: 1.0,
      },
      squareNarrow: {
        y: 99.84767150878906,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 99.58583068847656,
        scaleX: 0.85,
      },
      squareWide: {
        y: 95.50904846191406,
      },
    },
  },
  {
    id: 'SkinnyRound',
    svg: SkinnyRound,
    positioning: {
      pointNarrow: {
        y: 98.24522399902344,
        scaleX: 0.7,
      },
      pointMedium: {
        y: 100.49302673339844,
        scaleX: 0.8,
      },
      pointWide: {
        y: 94.26312255859375,
      },
      roundNarrow: {
        y: 95.99977111816406,
        scaleX: 0.7,
      },
      roundMedium: {
        y: 97.0762939453125,
        scaleX: 0.8,
      },
      roundWide: {
        y: 98.35804748535156,
        scaleX: 0.95,
      },
      squareNarrow: {
        y: 100.16455078125,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 95.30509948730469,
        scaleX: 0.8,
      },
      squareWide: {
        y: 94.42892456054688,
      },
    },
  },
  {
    id: 'NormalCircular',
    svg: NormalCircular,
    positioning: {
      pointNarrow: {
        y: 99.25872802734375,
        scaleX: 0.7,
      },
      pointMedium: {
        y: 100.88459777832031,
        scaleX: 0.8,
      },
      pointWide: {
        y: 92.8145751953125,
        scaleX: 0.9,
      },
      roundNarrow: {
        y: 98.73239135742188,
        scaleX: 0.7,
      },
      roundMedium: {
        y: 98.55126953125,
        scaleX: 0.8,
      },
      roundWide: {
        y: 100.65679931640625,
        scaleX: 0.9,
      },
      squareNarrow: {
        y: 99.20887756347656,
        scaleX: 0.7,
      },
      squareMedium: {
        y: 98.47904968261719,
        scaleX: 0.8,
      },
      squareWide: {
        y: 95.56983947753906,
        scaleX: 0.9,
      },
    },
  },
  {
    id: 'NormalRound',
    svg: NormalRound,
    positioning: {
      pointNarrow: {
        y: 96.03196716308594,
        scaleX: 0.8,
      },
      pointMedium: {
        y: 96.92947387695312,
        scaleX: 0.9,
      },
      pointWide: {
        y: 89.14988708496094,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 96.516357421875,
        scaleX: 0.8,
      },
      roundMedium: {
        y: 100,
        scaleX: 0.9,
      },
      roundWide: {
        y: 90.87593078613281,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 100,
        scaleX: 0.8,
      },
      squareMedium: {
        y: 96.78829956054688,
        scaleX: 0.9,
      },
      squareWide: {
        y: 92.16551208496094,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'SkinnyLongRound',
    svg: SkinnyLongRound,
    positioning: {
      pointNarrow: {
        y: 95.71734619140625,
        scaleX: 0.7,
      },
      pointMedium: {
        y: 95.9615478515625,
        scaleX: 0.8,
      },
      pointWide: {
        y: 88.25723266601562,
        scaleX: 0.95,
      },
      roundNarrow: {
        y: 95.76559448242188,
        scaleX: 0.7,
      },
      roundMedium: {
        y: 100,
        scaleX: 0.8,
      },
      roundWide: {
        y: 92.49725341796875,
        scaleX: 0.9,
      },
      squareNarrow: {
        y: 100,
        scaleX: 0.7,
      },
      squareMedium: {
        y: 96.198486328125,
        scaleX: 0.8,
      },
      squareWide: {
        y: 100,
        scaleX: 0.9,
      },
    },
  },
  {
    id: 'SkinnySquarePointy',
    svg: SkinnySquarePointy,
    positioning: {
      pointNarrow: {
        y: 96.57942199707031,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 97.19749450683594,
        scaleX: 0.83,
      },
      pointWide: {
        y: 92.27885437011719,
      },
      roundNarrow: {
        y: 95.64894104003906,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 99,
        scaleX: 0.83,
      },
      roundWide: {
        y: 93.87373352050781,
      },
      squareNarrow: {
        y: 98,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 95.59483337402344,
        scaleX: 0.88,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
  {
    id: 'SkinnyDiagonalPointy',
    svg: SkinnyDiagonalPointy,
    positioning: {
      pointNarrow: {
        y: 96.57942199707031,
        scaleX: 0.7,
      },
      pointMedium: {
        y: 97.19749450683594,
        scaleX: 0.8,
      },
      pointWide: {
        y: 92.27885437011719,
      },
      roundNarrow: {
        y: 97.64894104003906,
        scaleX: 0.7,
      },
      roundMedium: {
        y: 100,
        scaleX: 0.8,
      },
      roundWide: {
        y: 93.87373352050781,
      },
      squareNarrow: {
        y: 100,
        scaleX: 0.7,
      },
      squareMedium: {
        y: 95.59483337402344,
        scaleX: 0.8,
      },
      squareWide: {
        y: 100,
        scaleX: 1.0,
      },
    },
  },
]

export default data
